export default (opened, event) => ({
    opened,
    field: null,

    init() {
        this.$watch('opened', (value) => {
            if (!value) {
                this.field = null;
            }

            document.body.classList.toggle('overflow-hidden', value);
        });

        Livewire.on(event, (data) => {
            this.opened = true;
            const field = _.get(data, 'payload.field');

            if (field !== undefined) {
                this.field = field;
            } else {
                this.field = null;
            }
        });
    },

    setFocus() {
        if (this.field === null) {
            return;
        }

        const input =
            document.querySelector(`[column="${this.field}"]`) ||
            document.querySelector(`[name\$=".${this.field}"]`) ||
            document.querySelector(`[name="${this.field}"]`) ||
            document.querySelector(`[id="${this.field}"]`);

        if (input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) {
            this.setFocusOnOpen(input);
            return;
        }

        const inputElement = document.querySelector(`[id="select-${this.field}"]`);

        if (inputElement instanceof HTMLInputElement) {
            this.setFocusOnOpen(inputElement, true);
        }
    },

    setFocusOnOpen(input, openDropDown = false) {
        let interval = null;
        clearInterval(interval);

        interval = setInterval(() => {
            input.focus();

            if (openDropDown) {
                input.dispatchEvent(new CustomEvent('apply-focus', { bubbles: true }));
            }

            clearInterval(interval);
        }, 200);
    },

    keyUp({ key, ctrlKey, target }, submitEvent = null) {
        if (key === 'Escape') {
            this.close();
        }

        if (
            key === 'Enter' &&
            submitEvent &&
            (target.nodeName !== 'TEXTAREA' || ctrlKey === true)
        ) {
            this.$wire.call(submitEvent);
        }
    },

    close() {
        this.$wire.call('close');
        this.$wire.dispatch(`${event}::close`);
    },
});
